module.exports = __webpack_public_path__ + "media/icons/ajax-loader-spotlight-1add5fd9.gif";